module.exports = __webpack_public_path__ + "img/m_bg5.39182a81.png";